const FIELDS = ['color', 'system', 'primers', 'reti', 'rasanti', 'surface'];

const initFieldValues = (mapper) => FIELDS.reduce(
  (prev, curr) => ({...prev, [curr]: mapper(curr)}),
  {}
);

export const flattenTintometersData = (surveys) => surveys?.reduce(
  (prev, row) => [
    ...prev,
    ...(Array.isArray(row.color)
      ? (
        row.color.length > 1
          ? [
            {...row, ...initFieldValues((_) => '')},  // placeholders that indicate nesting
            ...row.color.map((c, idx) => ({
              id: `${row.id}-${idx}`,
              parentId: row.id,
              ...initFieldValues((field) => field === 'color' ? c : row[field][idx]),
            }))
          ]
          : [{
            ...row,
            ...initFieldValues((field) => row[field][0])
          }]
      )
      : [row]
    )
  ],
  []
);